import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import { withContainerContext } from "../../../components/container/ContainerContext";
import FormCheckbox from "../../../components/form/FormCheckbox";
import ModalCheckboxGrid from "../../../components/modal/ModalCheckboxGrid";
import ModalDescription from "../../../components/modal/ModalDescription";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import batchOperations from "../../../modules/batchOperations";
import { PropTypeShapes } from "../../../types";
import preprocessorQuery from "../../../utils/preprocessorQuery";

const isIos = preprocessorQuery.isIos();

const renderNarrativeGroup = useProps => {
  const onIncludeNarrativeChange = value =>
    useProps.dispatchLocal(
      batchOperations.changeIncludeNarrativeAndIncludeType(
        value,
        useProps.defaultNarrativeType,
        useProps.defaultSequenceType
      )
    );
  return (
    <ModalGroup key="narrativeGroup">
      <ModalRow key="description">
        <ModalDescription>
          <span>
            The narrative is useful for organising events into chapters or scenes when telling a non-linear story. It
            allows you to organise events into a hierarchical structure independent of date order. This narrative order
            can be directly synced with your Scrivener or Ulysses project.
          </span>
        </ModalDescription>
      </ModalRow>
      <ModalRow key="includeNarrative">
        <ModalField>
          <div className="fullWidthOptions">
            <ModalCheckboxGrid>
              <FormCheckbox
                label="Enable Narrative"
                checkboxState={useProps.includeNarrative}
                onChange={onIncludeNarrativeChange}
              />
            </ModalCheckboxGrid>
          </div>
        </ModalField>
      </ModalRow>
      {!isIos && useProps.availableSyncProjects.length > 0 && !useProps.includeNarrative ? (
        <ModalRow>
          <ModalDescription>
            <span className="warning">Scrivener syncing will be removed if the narrative is disabled.</span>
          </ModalDescription>
        </ModalRow>
      ) : null}
      {isIos ? <br /> : null}
      <ModalRow>
        <ModalDescription>
          <span>You can enable or disable the narrative at any time from the timeline&apos;s settings.</span>
        </ModalDescription>
      </ModalRow>
    </ModalGroup>
  );
};

const NarrativePage = props => {
  return [renderNarrativeGroup(props)];
};

NarrativePage.propTypes = {
  isNarrativeAllowed: PropTypes.bool.isRequired,
  includeNarrative: PropTypes.bool.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  availableSyncProjects: PropTypes.arrayOf(PropTypes.string),
  defaultNarrativeType: PropTypes.string,
  defaultSequenceType: PropTypes.string.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(NarrativePage);
